import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { ButtonBase } from '../../../../shared/Button';

import { PickWinnersModal } from './PickWinnersModal.jsx';

import { FINISHED, PICKED } from '../../utils/constants';
import { useCampaignContext } from '../../contexts/CampaignContext.jsx';

import {
  setOpenWinnerModal,
  unSetOpenWinnerModal,
} from '../../../../lib/redux/campaignPrize/campaignPrizeSlice';

export const Winners = ({ prize, sortingStatus, changeSort }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('campaigns');
  const openWinnerModal = useSelector(
    state => state.campaignPrize.openWinnerModal,
  );
  const { campaign } = useCampaignContext();
  const isDisabled = campaign.isArchived || !!campaign.deletedAt;

  return (
    <>
      <PickWinnersModal
        prize={prize}
        sortingStatus={sortingStatus}
        changeSort={changeSort}
        modalOpen={openWinnerModal}
        closeModal={() => dispatch(unSetOpenWinnerModal())}
      />
      <PickWinnerBtn
        mode="text"
        variant="primary"
        disabled={isDisabled}
        onClick={() => dispatch(setOpenWinnerModal())}
      >
        {prize.status === FINISHED && t('prizes.pickWinners')}
        {prize.status === PICKED && t('prizes.editWinners')}
      </PickWinnerBtn>
    </>
  );
};

const PickWinnerBtn = styled(ButtonBase)`
  height: auto;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
`;
